import { TokenType } from '@/state/vault/domain'

export default [TokenType.Coin, TokenType.Ting, TokenType.Ephemeral, TokenType.Item]
